<template>
  <div id="app" ref="app" :class="{ noscroll: status }">
<!--    <app-download-banner/>-->
    <keep-alive>
      <router-view v-if="isRouterAlive && $route.meta.keepAlive" />
    </keep-alive>
    <router-view
      v-if="
        isRouterAlive &&
          ($route.meta.keepAlive == undefined || !$route.meta.keepAlive)
      "
    />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
// import AppDownloadBanner from "./components/package/AppDownloadBanner.vue";

export default {
  name: "App",
  components: {
    // AppDownloadBanner
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true,
      // windowWidth: window.innerWidth,
      windowWidth: window.document.documentElement.clientWidth,
      windowRedirectWidth: 1200
    };
  },
  created() {
    // console.log('navigator.userAgent: ', navigator.userAgent)
    // console.log('windowWidth: ', this.windowWidth)
    // console.log('windowRedirectWidth: ', this.windowRedirectWidth)
    // if ((/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent) && this.windowWidth <= this.windowRedirectWidth) || (navigator.userAgent.includes("Mac") && "ontouchend" in document)) {
    //   console.log("inside if")
    // window.open(window.location.href.replace('//m.','//').replace(':8083/',':8081/'), '_self')
    //   // window.open(window.location.href.replace(':8081/',':8083/'), '_self')
    // } else {
    //   console.log("inside else")
    //    window.open(window.location.href.replace(':8083/',':8081/'), '_self')
    // }
    console.log(
      "this.windowRedirectWidth < this.windowWidth: ",
      this.windowRedirectWidth < this.windowWidth
    );
    // if (this.windowRedirectWidth < this.windowWidth) {
    //   // window.open(window.location.href.replace('//m.','//').replace(':8083/',':8081/'), '_self')
    //   window.open(
    //     window.location.href.replace(
    //       process.env.VUE_APP_UNIFI_MOBILE,
    //       process.env.VUE_APP_UNIFI
    //     ),
    //     "_self"
    //   );
    //   // window.open(window.location.href.replace(':8083/',':8081/'), '_self')
    // }

    if (/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
      console.log('phone')
    } else {
      // window.open(
      //   window.location.href.replace(
      //     process.env.VUE_APP_UNIFI_MOBILE,
      //     process.env.VUE_APP_UNIFI
      //   ),
      //   "_self"
      // );
      window.open(window.location.href.replace('//m.','//').replace(':8083/',':8081/'), '_self')
    }


    if (this.$route.path.split("/")[1] === "private") {
      return;
    }
    this.fetchData();

    setTimeout(() => {
      window.location.reload(true);
    }, 60 * 60 * 1000); // 1 hour in milliseconds

    // const lastVisit = localStorage.getItem('lastVisit');
    // const now = Date.now();
    // const oneHour = 60 * 60 * 1000;
    // if (!lastVisit || now - lastVisit > oneHour) {
    //   localStorage.setItem('lastVisit', now);
    //   window.location.reload(true);
    // } else {
    //   localStorage.setItem('lastVisit', now);
    // }
  },
  methods: {
    ...mapActions("account", ["getInvoiceNums"]),
    ...mapMutations("login", ["setNumber"]),
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
        this.$refs.app.scrollTop = 0;
      });
    },
    fetchData() {
      // 获取消息通知
      //this.getInvoiceNums({callback: this.numCallback})
    },
    // 获取消息通知回调
    numCallback(res) {
      var that = this;
      if (res.data.code == 0) {
        that.setNumber({ number: res.data.data });
      } /*else if (res.data.code == 90000 || res.data.code == 90002) {
            localStorage.clear()
        } else if (res.data.code == 8902 || res.data.code == 8901) {
            localStorage.clear()
            if (that.$route.path !== '/update') {
              that.$box.alert('', res.data.message ,'error')
              that.$router.push('/login')
            }
        }*/
    },
    title: function() {
      var tenant = window.location.hostname
        .replace("m.", "")
        .split(".")[0]
        .split("testunifiproperty")[0]
        .split("unifiproperty")[0]
        .split("platform")[0];
      // document.title = tenant.toUpperCase()==""?"UNIFI Property":tenant.toUpperCase();
      document.title = "UNIFI Property";
    },
    onResize() {
      // this.windowWidth = window.innerWidth
      this.windowWidth = window.document.documentElement.clientWidth;
      console.log(
        "this.windowRedirectWidth < this.windowWidth: ",
        this.windowRedirectWidth < this.windowWidth
      );
      if (this.windowRedirectWidth < this.windowWidth) {
        console.log(
          "process.env.VUE_APP_UNIFI_MOBILE: ",
          process.env.VUE_APP_UNIFI_MOBILE
        );
        // window.open(window.location.href.replace('//m.','//').replace(':8083/',':8081/'), '_self')
        window.open(
          window.location.href.replace(
            process.env.VUE_APP_UNIFI_MOBILE,
            process.env.VUE_APP_UNIFI
          ),
          "_self"
        );
        // window.open(window.location.href.replace(':8083/',':8081/'), '_self')
        // }
        // if ((/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent) && this.windowWidth <= this.windowRedirectWidth) || (navigator.userAgent.includes("Mac") && "ontouchend" in document)) {
        // } else {
        //   window.open(window.location.href.replace('//m.','//').replace(':8083/',':8081/'), '_self')
      }
    },
    setBrowserIcon: function() {
      var link = document.querySelector("link[rel~='icon']");
      link.href = './assets/favicon.ico';
    },
  },
  beforeMount() {
    this.setBrowserIcon();
    this.title();
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  computed: {
    ...mapState({
      status: state => state.login.noScroll // 实时变化
    })
  },
  watch: {
    $route: "fetchData"
  }
};
</script>

<style lang="scss">
.select input {
  color: transparent;
  text-shadow: 0 0 0 #000;
}

.select .van-dropdown-menu__bar {
  height: 0.82rem;
  background-color: transparent;
  display: block;
  box-shadow: none;
}

.select .van-dropdown-menu__item {
  display: block;
  flex: none;
}

.select .van-dropdown-menu__title {
  float: left;
  line-height: 0.82rem;
  display: block;
  width: 100%;
  font-family: ProximaNova-Regular;
  color: #3f3f46;
  height: 0.82rem;
}

.select .van-dropdown-menu__title--down::after {
  right: 0.2rem;
  border-color: transparent transparent #3f3f46 #3f3f46;
}

.select .van-dropdown-menu__title::after {
  right: 0.2rem;
  border: 0.1rem solid;
  border-color: transparent transparent #3f3f46 #3f3f46;
}

.select .van-dropdown-item {
  width: 90%;
  left: 5%;
  box-sizing: border-box;
  border: 1px solid #eee;
  background: #fff;
  height: 7rem;
}

.titlewrap .van-dropdown-item {
  height: 3rem;
}

.titlewrap .van-dropdown-menu__title--down::after {
  border-color: transparent;
}

.titlewrap .van-dropdown-menu__title::after {
  border-color: transparent;
}

.select .van-dropdown-item__content {
  max-height: 100%;
}

.noscroll {
  height: 100vh;
  overflow: hidden;
}

.el-scrollbar {
  //element-ui 下拉框在ios上 点击两次才能
  > .el-scrollbar__bar {
    opacity: 1 !important;
  }
}

#app {
  font-family: ProximaNova-Regular;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0 auto;
}

.el-select-dropdown {
  z-index: 30 !important;
}

body,
p,
ul,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
  font-weight: normal;
}

li {
  list-style-type: none;
}

.clear:after {
  content: "";
  width: 0;
  height: 0;
  display: block;
  clear: both;
}

.select .el-select {
  display: block;
  border: none;
}

.select .el-input__inner {
  height: 0.9rem;
  line-height: 0.9rem;
  border: none;
  padding-left: 0.2rem;
}

.select .el-input--suffix .el-input__inner {
  background: transparent;
}

.sort .el-input--suffix .el-input__inner {
  padding-right: 0.6rem;
}

.select .el-select .el-input .el-select__caret {
  color: transparent;
}

.sort .el-select .el-input__inner {
  border: none;
  width: 5rem;
  text-align: right;
}

.sort .el-input__suffix {
  right: 0;
  top: -0.05rem;
}

.long .el-select .el-input__inner {
  border: none;
  width: 166px;
}

.sort .el-icon-arrow-up:before {
  content: "";
  display: inline-block;
  width: 0.3rem;
  height: 0.3rem;
  background-repeat: no-repeat;
  background-size: left top;
  background-position: center center;
  background-image: url("assets/arrw.png");
  transform: rotate(180deg);
}

.reserve .el-input--prefix .el-input__inner {
  border: none;
  padding: 0;
  height: 0.8rem;
  padding-left: 0.36rem;
  width: 100%;
}

.reserve .el-input__prefix {
  opacity: 0;
}

/* 分页 */
.pagination .van-pagination {
  display: block;
  text-align: center;
  height: 0.8rem;
  position: relative;
}

.select input {
  outline: none !important;
}

.pagination .van-pagination__item {
  display: inline-block;
  line-height: 0.8rem;
  width: 0.8rem;
  height: 0.8rem;
  background: rgba(245, 245, 247, 1);
  border-radius: 0.12rem;
  border: 1px solid rgba(223, 223, 223, 1);
  font-size: 0.3rem;
  font-family: ProximaNova-Semibold;
  color: #111;
  margin-right: 0.2rem;
  box-sizing: border-box;
}

.pagination .van-pagination__next,
.pagination .van-pagination__prev {
  width: 1.46rem;
  height: 0.8rem;
  background: rgba(245, 245, 247, 1);
  border: 1px solid rgba(223, 223, 223, 1);
  color: #111;
  box-sizing: border-box;
}

.pagination .van-pagination__prev {
  position: absolute;
  left: 0;
}

.pagination .van-pagination__next {
  position: absolute;
  right: 0;
}

.pagination .van-pagination__item--active {
  border: 1px solid rgba(44, 202, 115, 1);
  background: #fff;
  color: #2cca73;
  box-sizing: border-box;
}

.el-select-dropdown__item {
  font-family: ProximaNova-Regular, ProximaNova;
}

.swiper-slide {
  width: 100% !important;
}

.gallery-thumbs .swiper-wrapper {
  margin-left: -2.8rem;
}

.el-input {
  font-size: 0.28rem !important;
}

.el-select-dropdown__item {
  font-size: 0.28rem !important;
  height: 0.5rem !important;
  line-height: 0.5rem !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue